import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import MdmLink from '~/components/atoms/MdmLink.vue';
export default {
  name: 'RangeProduct',
  components: {
    MdmLink: MdmLink
  },
  props: {
    withLink: {
      type: String,
      default: ''
    },
    link: {
      type: String,
      default: ''
    },
    ratioImg: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      default: ''
    },
    range: {
      type: String,
      default: ''
    },
    product: {
      type: String,
      default: ''
    },
    price: {
      type: String,
      default: ''
    },
    button: {
      type: String,
      default: ''
    }
  }
};